
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import g from '../globals/variables'

const RecipesAnimations = {
  

  init(): void {
    if (!document.querySelector('.doc-ljufalif')) {
      return
    }

    gsap.registerPlugin(ScrollTrigger)

    this.animateCards()
    this.animateHeaderAndHero()
    this.animateRecipe()
    this.animateSections()
  },

  animateCards(): void {
    const selectors = `
      .card-grid > .grid > *,
      .recipes-categories-layout .category-card
    `

    if (!document.querySelector('.card-grid') && !document.querySelector('.recipes-categories-layout')) {
      return
    }

    gsap.set(selectors, { opacity: 0, y: 25 })

    ScrollTrigger.batch(selectors, {
      start: 'top 90%',
      onEnter: (batch) => {
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          stagger: 0.21,
          duration: 1.5,
          ease: 'back.out',
        })
      },
    })

    document.querySelectorAll(selectors).forEach((card) => {
      ScrollTrigger.create({
        onLeaveBack: () => {
          gsap.set(card, {
            opacity: 0,
            overwrite: true,
            y: 25,
          })
        },
        start: 'top 100%',
        trigger: card,
      })
    })
  },

  animateHeaderAndHero(): void {
    gsap.matchMedia().add(g.breakpoints, (context) => {
      const is = context.conditions

      const onComplete = () => {
        sessionStorage.setItem('recipesLoaded', 'true')
      }

      if (sessionStorage.getItem('recipesLoaded') === 'true') {
        return
      }

      gsap.set('.recipes-navigation__logo', { opacity: 0})
      gsap.set('.recipes-navigation__logo svg g:last-child path', { opacity: 0, scaleX: 0, transformOrigin: '50% 50%' })

      if (document.querySelector('.hero')) {
        gsap.set('.hero', { opacity: 0, y: -60 })
        gsap.set('.hero .recipes-line', { opacity: 0 })
      }

      if (is.mobile) {
        gsap
        .timeline({ defaults: { clearProps: 'all' }})
        .to('.recipes-navigation__logo', { delay: 0.2, opacity: 1 })
        .to('.recipes-navigation__logo svg g:last-child path', { duration: 1.5, ease: 'power3.out', opacity: 1, scaleX: 1 }, '<')
        .to('.hero', { duration: 1.5, onComplete, opacity: 1, y: 0 }, '<0.4')
        .to('.hero .recipes-line', { duration: 1.5, opacity: 1 }, '<1')
      }

      if (is.tablet || is.desktop) {
        gsap.set('.recipes-navigation__nav, .recipes-navigation__nav-link', { opacity: 0 })

        gsap
          .timeline({ defaults: { clearProps: 'all' }})
          .to('.recipes-navigation__logo', { delay: 0.2, opacity: 1 })
          .to('.recipes-navigation__logo svg g:last-child path', { duration: 1.5, ease: 'power3.out', opacity: 1, scaleX: 1 }, '<')
          .to('.recipes-navigation__nav', { duration: 1.5, delay: 0.4, opacity: 1 }, '<0.2')
          .to('.recipes-navigation__nav-link', { duration: 0.5, opacity: 1, stagger: 0.21 }, '<')
          .to('.hero', { duration: 1.5, onComplete, opacity: 1, y: 0 }, '<0.4')
          .to('.hero .recipes-line', { duration: 1.5,opacity: 1 }, '<1')
      }
    })

    
  },

  animateRecipe(): void {
    const selectors = `
      .recipe-article__headline,
      .recipe-article__overview-image-container,
      .recipe-article__overview-description-container,
      .recipe-article__instructions-headline,
      .recipe-article__instructions,
      .recipe-article__ingredients
    `

    if (!document.querySelector('.recipe-article__overview')) {
      return
    }

    gsap.set(selectors, { opacity: 0, y: -75 })

    ScrollTrigger.batch(selectors, {
      start: 'top 90%',
      onEnter: (batch) => {
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          stagger: 0.21,
          duration: 1.5,
          ease: 'back.out',
        })
      },
    })

    document.querySelectorAll(selectors).forEach((item) => {
      ScrollTrigger.create({
        onLeaveBack: () => {
          gsap.set(item, {
            opacity: 0,
            overwrite: true,
            y: -75,
          })
        },
        start: 'top 100%',
        trigger: item,
      })
    })

  },

  animateSections(): void {
    document.querySelectorAll(`
      .text-block,
      .featured-categories-block,
      .featured-recipes-block,
      .featured-video-block,
      .recipe-profile-summary,
      .recipes-brochures__cards,
      .recipes-categories-layout,
      .recipes-category__cards,
      .recipes-cta-block,
      .recipes-page-navigation,
      .recipes-videos__videos
    `).forEach((section) => {
      gsap.set(section, { opacity: 0, y: -75 })

      ScrollTrigger.create({
        onEnter: () => {
          gsap.to(section, {
            clearProps: 'all',
            duration: 1.5,
            ease: 'back.out',
            opacity: 1,
            y: 0,
          })
        },
        start: 'top 90%',
        trigger: section?.firstElementChild || section,
      })

      ScrollTrigger.create({
        onLeaveBack: () => {
          gsap.set(section, {
            opacity: 0,
            overwrite: true,
            y: -75,
          })
        },
        start: 'top 100%',
        trigger: section?.firstElementChild || section,
      })
    })
  },
}

export default RecipesAnimations
